import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

interface IProps {
  prodUrl: (value: string) => string;
}

const MobileDiscoveriesSection = ({ prodUrl }: IProps): ReactElement => {
  const { t: tMobile } = useTranslation('', {
    keyPrefix: '$pages.$home.$mobileHomePage.$discoveriesSection',
  });

  return (
    <section className="mobile-discoveries">
      <h2 dangerouslySetInnerHTML={{ __html: tMobile('discoveriesTitle') }} />
      <Link href={prodUrl('wobbleChess')} className="img-frame right">
        <img
          src="/statics/img/mobile/chess.webp"
          alt={tMobile('wobbleChessImageAlt')}
          width={667}
          height={360}
          loading="lazy"
          decoding="async"
          fetchPriority="low"
        />
        <h3 className="subtitle">{tMobile('discoveryProd1')}</h3>
      </Link>
    </section>
  );
};

export default MobileDiscoveriesSection;
